function n(t) {
  return t ? parseInt(t, 10) : 0;
}
export {
  n as t
};
